module.exports = __webpack_public_path__ + "img/areabg.3cfb9851.png";